const maskVerifyCode = ( value: string ): string => {
  const x = value.match( /(\d{0,6})/ );
  return !!x ? x[1] : '';
};



export default maskVerifyCode;
